<template>
  <v-container>
    <page-header v-if="region" :title="region.label.cyrillic" :info="lang.regionInfo(region.label.cyrillic)" />
    <grid :items="items" :headers="headers" />
    <div hidden v-if="region" v-html="lang.regionInfo(region.label.cyrillic)" :class="['meta-description']" />
  </v-container>
</template>
<script>
import lang from '../helpers/lang'
import methods from '../helpers/methods'
import data from '../helpers/data'

export default {
  name: 'regions-region',
  mixins: [
    data,
    methods
  ],
  data () {
    return {
      lang,
      region: null
    }
  },
  mounted () {
    this.getRegionConfig()
  },
  watch: {
    /**
     * route.params.region watcher
     */
    '$route.params.region' () {
      this.getRegionConfig()
    }
  },
  methods: {
    /**
     * Get the page data from the API
     * @method getRegionConfig
     * @return {void}
     */
    getRegionConfig () {
      this.region = this.$root.regions.find(region => region.id === this.$route.params.region)
      this.getTabularData('regions', this.region.id, 'region', () => {
        this.$nextTick(() => {
          this.setLastBreadcrumbsItemText(this.region.label.cyrillic)
        })
      })
      this.$nextTick(() => {
        this.emitRouteChange()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/regions-region.vue